require("bootstrap/js/alert");
require("bootstrap/js/collapse");

import * as angular from "angular";

const app = angular.module("igsSolarOps", [
  "ui.router",
  "ui.bootstrap",
  "ui.mask",
  "ngAria",
  "ngAnimate",
  "ngToast",
  "ngMaterial",
  "igs.waitMask",
  "igs.grid",
  "igs.identity",
  "igs.common.inputs",
  "igs.common.validation",
  "igs.common.credit.card.validation",
  "igs.common.ach.validation",
  "ngFileUpload",
  "ngFileSaver",
  "angular-timeline",
]);

import { react2angular } from "react2angular";
import "./Common/css/angular-material.css";
import "./Common/css/daterangepicker.css";
import "./Common/css/font-awesome-4-7-0.min.css";
import "./Common/css/igsWaitMask.css";
import "./Common/css/ngToast-animations.min.css";
import "./Common/css/ngToast.min.css";
import "./Common/css/style.css";
import "./Common/css/toastr-2-1-2.css";
import "./Common/modules/ApiClientService";
import "./Common/modules/ErrorHandlerService";
import "./Common/modules/Identity";
import "./Common/modules/IGSAchValidation";
import "./Common/modules/IGSCreditValidation";
import "./Common/modules/IGSValidation";
import "./Common/modules/MessageBox";
import "./Common/modules/UIWaitMask";
import * as Directives from "./Directives";
import "./Directives/DateRangeValidationDirectives.js";
import "./Directives/DecimalPrecisionDirective.js";
import "./Directives/DropdownMultiselect.js";
import "./Directives/InputFormatDirective.js";
import * as Filters from "./Filters";
import * as Routes from "./Routes";
import * as Services from "./Services";
import * as Shared from "./Shared";

//// Services
app.service("ApiClient", Shared.Framework.ServiceHelpers.create(Services.ApiClient.ApiClient));
app.service("AuthApiClient", Shared.Framework.ServiceHelpers.create(Services.AuthApiClient.AuthApiClient));
app.service("PriorityService", Shared.Framework.ServiceHelpers.create(Services.PriorityService.PriorityService));
app.service("BrandingService", Shared.Framework.ServiceHelpers.create(Services.BrandingService.BrandingService));
app.service(
  "CallRecordingApiClient",
  Shared.Framework.ServiceHelpers.create(Services.CallRecordingApiClient.CallRecordingApiClient),
);
app.service(
  "CostCalculationApiClient",
  Shared.Framework.ServiceHelpers.create(Services.CostCalculationApiClient.CostCalculationApiClient),
);
app.service(
  "CreditCheckApiClient",
  Shared.Framework.ServiceHelpers.create(Services.CreditCheckApiClient.CreditCheckApiClient),
);
app.service("CustomerApiClient", Shared.Framework.ServiceHelpers.create(Services.CustomerApiClient.CustomerApiClient));
app.service("DocumentApiClient", Shared.Framework.ServiceHelpers.create(Services.DocumentApiClient.DocumentApiClient));
app.service(
  "WorkIssueApiClient",
  Shared.Framework.ServiceHelpers.create(Services.WorkIssueApiClient.WorkIssueApiClient),
);
app.service("UserService", Shared.Framework.ServiceHelpers.create(Services.UserService.UserService));
app.service("DocusignApiClient", Shared.Framework.ServiceHelpers.create(Services.DocusignApiClient.DocusignApiClient));
app.service(
  "DocusignRedirectApiClient",
  Shared.Framework.ServiceHelpers.create(Services.DocusignRedirectApiClient.DocusignRedirectApiClient),
);
app.service("InvoiceApiClient", Shared.Framework.ServiceHelpers.create(Services.InvoiceApiClient.InvoiceApiClient));
app.service(
  "MarketAssumedValuesApiClient",
  Shared.Framework.ServiceHelpers.create(Services.MarketAssumedValuesApiClient.MarketAssumedValuesApiClient),
);
app.service(
  "PartnerApiClientService",
  Shared.Framework.ServiceHelpers.create(Services.PartnerApiClientService.PartnerApiClientService),
);
app.service(
  "PartnerRetrievalService",
  Shared.Framework.ServiceHelpers.create(Services.PartnerRetrievalService.PartnerRetrievalService),
);
app.service(
  "PaymentCaptureApiClient",
  Shared.Framework.ServiceHelpers.create(Services.PaymentCaptureApiClient.PaymentCaptureApiClient),
);
app.service(
  "StatePermissionsMappingService",
  Shared.Framework.ServiceHelpers.create(Services.StatePermissionsMappingService.StatePermissionsMappingService),
);
app.service("SystemApiClient", Shared.Framework.ServiceHelpers.create(Services.SystemApiClient.SystemApiClient));
app.service(
  "UpdatePaymentMethodApiClient",
  Shared.Framework.ServiceHelpers.create(Services.UpdatePaymentMethodApiClient.UpdatePaymentMethodApiClient),
);
app.service(
  "PartnerSettingsApiClientService",
  Shared.Framework.ServiceHelpers.create(Services.PartnerSettingsApiClientService.PartnerSettingsApiClientService),
);
app.service(
  "SrecPriceCurveApiClient",
  Shared.Framework.ServiceHelpers.create(Services.SrecPriceCurveApiClient.SrecPriceCurveApiClient),
);
app.service("ScriptsApiClient", Shared.Framework.ServiceHelpers.create(Services.ScriptsApiClient.ScriptsApiClient));
app.service(
  "ProductionEstimationApiClient",
  Shared.Framework.ServiceHelpers.create(Services.ProductionEstimationApiClient.ProductionEstimationApiClient),
);
app.service(
  "WeatherStationApiClient",
  Shared.Framework.ServiceHelpers.create(Services.WeatherStationApiClient.WeatherStationApiClient),
);
app.service(
  "ProcessReviewInvoiceApiClient",
  Shared.Framework.ServiceHelpers.create(Services.ProcessReviewInvoiceApiClient.ProcessReviewInvoiceApiClient),
);
app.service("PricingApiClient", Shared.Framework.ServiceHelpers.create(Services.PricingApiClient.PricingApiClient));
app.service("BannerApiClient", Shared.Framework.ServiceHelpers.create(Services.BannerApiClient.BannerApiClient));
app.service(
  "OpportunityApiClient",
  Shared.Framework.ServiceHelpers.create(Services.OpportunityApiClient.OpportunityApiClient),
);

// Directives
app.directive(
  "addressDisplay",
  Shared.Framework.DirectiveHelpers.create(Directives.AddressDisplay.AddressDisplayDirective),
);
app.directive(
  "creditCheckNameInequality",
  Shared.Framework.DirectiveHelpers.create(
    Routes.Customer.Misc.creditCheckNameInequality.CreditCheckNameInequalityController,
  ),
);
app.directive("clickOnce", Shared.Framework.DirectiveHelpers.create(Directives.ClickOnceDirective.ClickOnceDirective));
app.directive("turnAutofillOff", Shared.Framework.DirectiveHelpers.create(Directives.TurnAutofillOff.TurnAutofillOff));
app.directive("dateFormat", Shared.Framework.DirectiveHelpers.create(Directives.DateFormat.DateFormatDirective));
app.directive(
  "datePicker",
  Shared.Framework.DirectiveHelpers.create(Directives.DatePickerDirective.DatePickerDirective),
);
app.directive("igsDate", Shared.Framework.DirectiveHelpers.create(Directives.DateTimePickerDirective.DateDirective));
app.directive("invoices", Shared.Framework.DirectiveHelpers.create(Directives.InvoicesDirective.InvoicesDirective));
app.directive(
  "menuToggle",
  Shared.Framework.DirectiveHelpers.create(Directives.ToggleMenuDirective.ToggleMenuDirective),
);
app.directive(
  "pageNavigator",
  Shared.Framework.DirectiveHelpers.create(Directives.PageNavigatorDirective.PageNavigatorDirective),
);
app.directive(
  "setBannerColor",
  Shared.Framework.DirectiveHelpers.create(Directives.SetBannerColorDirective.SetBannerColorDirective),
);
app.directive("documentManager", [() => new Directives.DocumentManagerDirective.DocumentManagerDirective()]);
app.directive(
  "contractOptionTile",
  Shared.Framework.DirectiveHelpers.create(Directives.ContractOptionTile.ContractOptionTileDirective),
);
app.directive(
  "associatedEpcCalculationTable",
  Shared.Framework.DirectiveHelpers.create(
    Directives.AssociatedEpcCalculationTable.AssociatedEpcCalculationTableDirective,
  ),
);
app.directive(
  "headerLogo",
  Shared.Framework.DirectiveHelpers.create(Directives.HeaderLogoDirective.HeaderLogoDirective),
);
app.directive(
  "dateWithinOneYear",
  Shared.Framework.DirectiveHelpers.create(Directives.DateValidationDirectives.DateWithinOneYear),
);
app.directive(
  "dateLessThanEqualToday",
  Shared.Framework.DirectiveHelpers.create(Directives.DateValidationDirectives.DateLessThanEqualToday),
);
app.directive(
  "dateCannotBeSame",
  Shared.Framework.DirectiveHelpers.create(Directives.DateValidationDirectives.DateCannotBeSame),
);
app.directive(
  "ignoreMouseWheel",
  Shared.Framework.DirectiveHelpers.create(Directives.IgnoreMouseWheelDirective.IgnoreMouseWheelDirective),
);
app.directive(
  "costCalculationDetails",
  Shared.Framework.DirectiveHelpers.create(Directives.Customer.CostCalculationDirective.CostCalculationDirective),
);
app.directive("validName", Shared.Framework.DirectiveHelpers.create(Directives.ValidNameDirective.ValidName));
app.directive(
  "validTrustName",
  Shared.Framework.DirectiveHelpers.create(Directives.ValidTrustNameDirective.ValidTrustName),
);
app.directive(
  "validServiceAddress",
  Shared.Framework.DirectiveHelpers.create(Directives.ValidServiceAddressDirective.ValidServiceAddress),
);
// Filters
app.filter("bytes", Shared.Framework.FilterHelpers.create(Filters.ByteFilter.byteFilter));
app.filter("epcPriceFilter", Shared.Framework.FilterHelpers.create(Filters.EpcPriceFilter.epcPriceFilter));
app.filter(
  "telephoneNumberFilter",
  Shared.Framework.FilterHelpers.create(Filters.TelephoneFilter.telephoneNumberFilter),
);

// Controllers
app.controller("MainCtrl", Shared.Framework.ControllerHelpers.create(Routes.main.MainCtrl));
app.controller("InvoiceCtrl", Shared.Framework.ControllerHelpers.create(Routes.Invoices.invoice.InvoiceCtrl));

app.controller(
  "ResidentialPaymentCaptureCtrl",
  Shared.Framework.ControllerHelpers.create(
    Routes.PaymentCapture.residentialPaymentCapture.ResidentialPaymentCaptureCtrl,
  ),
);

app.controller(
  "ResidentialPaymentCaptureConfirmationCtrl",
  Shared.Framework.ControllerHelpers.create(
    Routes.PaymentCapture.residentialPaymentCaptureConfirmation.ResidentialPaymentCaptureConfirmationCtrl,
  ),
);
app.controller(
  "CostCalculationAssumedValuesCtrl",
  Shared.Framework.ControllerHelpers.create(
    Routes.CostCalculation.costCalculationAssumedValues.CostCalculationAssumedValuesCtrl,
  ),
);
app.controller(
  "UpdatePaymentMethodCustomerCtrl",
  Shared.Framework.ControllerHelpers.create(
    Routes.UpdatePaymentMethod.updatePaymentMethodCustomerCtrl.UpdatePaymentMethodCustomerCtrl,
  ),
);
app.controller(
  "ResendInvoiceModalCtrl",
  Shared.Framework.ControllerHelpers.create(Routes.Customer.Misc.resendInvoiceModal.ResendInvoiceModalCtrl),
);
app.controller(
  "OverpaymentConfirmationModalCtrl",
  Shared.Framework.ControllerHelpers.create(
    Routes.UpdatePaymentMethod.overpaymentConfirmationModal.OverpaymentConfirmationModalCtrl,
  ),
);
// Customer
app.controller("CustomerCtrl", Shared.Framework.ControllerHelpers.create(Routes.Customer.customer.CustomerCtrl));
app.controller(
  "AddressVerificationModalCtrl",
  Shared.Framework.ControllerHelpers.create(Routes.Customer.addressVerificationModalCtrl.AddressVerificationModalCtrl),
);
app.controller(
  "ConfirmNewDocusignRemoteSendCtrl",
  Shared.Framework.ControllerHelpers.create(
    Routes.Customer.Misc.confirmNewDocusignRemoteSend.ConfirmNewDocusignRemoteSendCtrl,
  ),
);
app.controller(
  "CustomerDocumentManagementCtrl",
  Shared.Framework.ControllerHelpers.create(
    Routes.Customer.Misc.customerDocumentManagement.CustomerDocumentManagementCtrl,
  ),
);
app.controller(
  "InvalidSolicitorNumberCtrl",
  Shared.Framework.ControllerHelpers.create(
    Routes.Customer.Misc.invalidSolicitorNumber.InvalidSolicitorNumberController,
  ),
);
app.controller(
  "SubmitMilestoneCtrl",
  Shared.Framework.ControllerHelpers.create(Routes.Customer.SubmitMilestone.SubmitMilestoneCtrl),
);
app.controller("DocumentManagerCtrl", Directives.DocumentManagerDirective.DocumentManagerCtrl);
app.controller(
  "ManageBatchesCtrl",
  Shared.Framework.ControllerHelpers.create(Routes.Admin.manageBatches.ManageBatchesCtrl),
);
app.controller(
  "SubmitAdditionalInvoiceCtrl",
  Shared.Framework.ControllerHelpers.create(Routes.Customer.SubmitAdditionalInvoice.SubmitAdditionalInvoiceCtrl),
);

// react
app.component("invoiceComponent", react2angular(Routes.Invoices.InvoiceComponent, ["permissions"]));

app.config([
  "$stateProvider",
  "$urlMatcherFactoryProvider",
  "$urlRouterProvider",
  "$locationProvider",
  (
    $stateProvider: angular.ui.IStateProvider,
    $urlMatcherFactory: angular.ui.IUrlMatcherFactory,
    $urlRouterProvider: angular.ui.IUrlRouterProvider,
    $locationProvider: ng.ILocationProvider,
  ) => {
    $urlMatcherFactory.caseInsensitive(true);
    $urlMatcherFactory.strictMode(false);
    $urlRouterProvider.otherwise("/");
    $urlRouterProvider.when("/Property/Search", "/v2/create-opportunity");

    $locationProvider.hashPrefix("");

    $stateProvider
      .state("main", {
        abstract: true,
        template: require("./Routes/main.html"),
        controller: "MainCtrl as mainCtrl",
      })
      .state("main.redirecttosearch", {
        url: "/customer/search", // Do not treat 'search' as a customer number/id.
        abstract: true,
        redirectTo: "main.customersearchv2",
      })
      .state("main.invoices", {
        url: "/invoices",
        template: require("./Routes/Invoices/invoice.html"),
        controller: "InvoiceCtrl as invoiceCtrl",
      })
      .state("main.updatePaymentMethodCustomer", {
        url: "/UpdatePaymentMethod/:abpAccountNumber",
        template: require("./Routes/UpdatePaymentMethod/updatePaymentMethodCustomer.html"),
        controller: "UpdatePaymentMethodCustomerCtrl as updatePaymentMethodCustomerCtrl",
        params: {
          abpAccountNumber: { value: null },
        },
      })

      // Issues
      .state("main.allIssues", {
        url: "/v2/issue-search",
        params: { isReact: true },
      })
      .state("main.upsertIssue", {
        url: "/Issue/:issueId",
        params: { isReact: true },
      })
      .state("main.issueCreate", {
        url: "/Issues/new/:igsCustomerNumber",
        params: { isReact: true },
      })

      // User Management
      .state("main.usermanagement", {
        url: "/usermanagement",
        params: { isReact: true },
      })
      .state("main.usermanagement.editgroup", {
        url: "/group/{id}",
        params: { isReact: true },
      })
      .state("main.usermanagement.editpartner", {
        url: "/partner/{code}",
        params: { isReact: true },
      })
      .state("main.usermanagement.editrole", {
        url: "/permission/{id}",
        params: { isReact: true },
      })
      .state("main.usermanagement.edituser", {
        url: "/user/{id}",
        params: { isReact: true },
      })
      .state("main.usermanagement.search.groups", {
        url: "/groups",
        params: { isReact: true },
      })
      .state("main.usermanagement.search.partners", {
        url: "/partners",
        params: { isReact: true },
      })
      .state("main.usermanagement.search.roles", {
        url: "/permissions",
        params: { isReact: true },
      })
      .state("main.usermanagement.search.users", {
        url: "/users",
      })

      //covered in v2
      .state("main.customeredit", {
        url: "/customer/{igsCustomerNumber}/edit",
        params: {
          isReact: true,
          igsCustomerNumber: { value: null },
        },
      })
      .state("main.submitSystemDetails", {
        url: "/SubmitSystemDetails/:igsCustomerNumber",
        params: { isReact: true, igsCustomerNumber: { value: null } },
      })
      .state("main.reconcileSystemData", {
        url: "/ReconcileSystemData/:igsCustomerNumber",
        params: { isReact: true, igsCustomerNumber: { value: null } },
      })
      .state("main.costCalculationAssociate", {
        url: "/CostCalculationAssociate/:partnerSystemNumber",
        params: {
          isReact: true,
        },
      })
      .state("main.customer", {
        url: "/customer/{igsCustomerNumber}",
        params: {
          isReact: true,
          igsCustomerNumber: { value: null },
        },
      })
      .state("main.manageSystemDetails", {
        url: "/ManageSystemDetails/:igsCustomerNumber",
        params: { isReact: true, igsCustomerNumber: { value: null } },
      })
      .state("main.usermanagement.search", {
        url: "/search",
        params: { isReact: true },
      })

      //already in react
      .state("main.customerv2", {
        url: "/v2/system-details/:igsCustomerNumber/overview",
        params: {
          igsCustomerNumber: { value: null },
          isReact: true,
        },
      })
      .state("main.costCalculationAssumedValues", {
        url: "/CostCalculationAssumedValues",
        template: require("./Routes/CostCalculation/costCalculationAssumedValues.html"),
        controller: "CostCalculationAssumedValuesCtrl as costCalculationAssumedValuesCtrl",
        params: { isReact: true },
      })
      .state("login", {
        url: "/login",
        params: { isReact: true },
      })
      .state("logout", {
        url: "/logout",
        params: { isReact: true },
      })
      .state("resetpassword", {
        url: "/resetpassword/:resetPasswordCode",
        params: { isReact: true },
      })
      .state("submitresetpassword", {
        url: "/submitresetpassword",
        params: { isReact: true },
      })
      .state("updatepassword", {
        url: "/UpdatePassword",
        params: { isReact: true },
      })
      .state("main.customersearch", {
        url: "/",
        params: { isReact: true },
      })
      .state("main.customersearchv2", {
        url: "/v2",
        params: { isReact: true },
      })
      .state("main.costCalculationSandbox", {
        url: "/v2/epc-sandbox-calculator",
        params: { isReact: true },
      })
      .state("main.residentialPaymentCapture", {
        url: "/ResidentialPaymentCapture/:igsCustomerNumber",
        params: { igsCustomerNumber: { value: null }, isReact: true },
      })
      .state("main.residentialPaymentCaptureConfirmation", {
        url: "/ResidentialPaymentCapture/Confirmation/:igsCustomerNumber",
        params: { igsCustomerNumber: { value: null }, isReact: true },
      })
      .state("main.createPaymentPlan", {
        url: "/PaymentPlan/:abpAccountNumber",
        params: { abpAccountNumber: { value: null }, isReact: true },
      })
      .state("main.usermanagement.changepassword", {
        url: "/v2/site-management/change-password",
        params: { isReact: true },
      })
      .state("main.amendnameaddress", {
        url: "/amendnameaddress/:igsCustomerNumber",
        params: { igsCustomerNumber: { value: null }, isReact: true },
      })
      .state("main.usermanagement.sendpasswordreset", {
        url: "/admin/userManagement/sendPasswordReset",
        params: { isReact: true },
      })
      .state("main.submitVerificationCall", {
        url: "/VerificationCall/:igsCustomerNumber",
        params: { igsCustomerNumber: { value: null }, isReact: true },
      })
      .state("main.submitMilestone", {
        url: "/processreview/submitMilestone/:igsCustomerNumber?ptoLetterOnly=:isPtoLetterOnly",
        params: { igsCustomerNumber: { value: null }, isReact: true, isPtoLetterOnly: { value: "0" } },
        template: require("./Routes/Customer/submitMilestone.html"),
        controller: "SubmitMilestoneCtrl as submitMilestoneCtrl",
      })
      .state("main.submitAdditionalInvoice", {
        url: "/processreview/SubmitAdditionalInvoice/:igsCustomerNumber",
        params: { igsCustomerNumber: { value: null }, isReact: true },
        template: require("./Routes/Customer/submitAdditionalInvoice.html"),
        controller: "SubmitAdditionalInvoiceCtrl as submitAdditionalInvoiceCtrl",
      })
      .state("main.pricingOverride", {
        url: "/PricingOverride/:igsCustomerNumber",
        params: { igsCustomerNumber: { value: null }, isReact: true },
      })
      .state("main.adminManageBatches", {
        url: "/processreview/batches/manage",
        params: { isReact: true },
      })
      .state("main.adminApproveBatches", {
        url: "/processreview/batches/approve",
        params: { isReact: true },
      })
      .state("main.milestoneInvoiceQueue", {
        url: "/processreview/invoices/queue",
        params: { isReact: true },
      })
      .state("main.adminManageBanners", {
        url: "/admin/managebanners",
        params: { isReact: true },
      })
      .state("main.manageCustomerNotices", {
        url: "/Customer/ManageNotices/:igsCustomerNumber",
        params: { igsCustomerNumber: { value: null }, isReact: true },
      })
      .state("main.preliminarySystemDetails", {
        url: "/PreliminarySystemDetails/:partnerSystemNumber",
        params: { partnerSystemNumber: { value: null }, isReact: true },
      })
      .state("main.manageResiInvoice", {
        url: "/Billing/ResidentialInvoices",
        params: { isReact: true },
      })
      .state("main.processReviewChecklist", {
        url: "/processreview/checklist/:igsCustomerNumber",
        params: { igsCustomerNumber: { value: null }, isReact: true },
      })
      .state("main.createOpportunity", {
        url: "/v2/create-opportunity",
        params: { isReact: true },
      })
      .state("main.propertySearch", {
        url: "/v2/create-opportunity",
        params: { isReact: true },
      })
      .state("main.opportunityPropertyRecord", {
        url: "/opportunity/:partnerSystemNumber/propertyRecord",
        params: { partnerSystemNumber: { value: null }, isReact: true },
      })
      .state("main.selectCustomer", {
        url: "/opportunity/:partnerSystemNumber/customers?shouldReturnToOpportunitySearch=:shouldReturnToOpportunity",
        params: { partnerSystemNumber: { value: null }, shouldReturnToOpportunity: { value: "0" }, isReact: true },
      })
      .state("main.submissionApproval", {
        url: "/processreview/approvePtoMilestone/:igsCustomerNumber?ptoLetterOnly=:isPtoLetterOnly",
        params: { isReact: true, isPtoLetterOnly: { value: "0" } },
      })
      .state("main.syncMonitoringSystem", {
        url: "/Monitoring/Systems/:systemKey/Sync",
        params: { systemKey: { value: null }, isReact: true },
      })
      .state("main.extensionRequests", {
        url: "/extension-requests",
        params: { isReact: true },
      })
      .state("main.epcPricing", {
        url: "/pricing/pages/epcPricing",
        params: { isReact: true },
      })
      .state("main.requestProjectExtension", {
        url: "/v2/project-extensions/:igsCustomerNumber",
        params: { systemKey: { value: null }, isReact: true },
      });
  },
]);

export const getReactUrl = (): String => {
  var url = "/app/#";
  if (window.location.hostname === "localhost") {
    url = "http://localhost:3000" + url;
  }
  return url;
};

const makeDiv = (): HTMLDivElement => {
  const lines = ["40% Total ITC", "30% Base ITC", "10% Energy Community Bonus"];
  const newDiv = document.createElement("div");
  newDiv.className = "tooltipContent";
  for (var l in lines) {
    var el = document.createElement("div");
    el.innerHTML = lines[l];
    newDiv.appendChild(el);
  }
  return newDiv;
};

export const handleAdderGroupTooltip = (): void => {
  setTimeout(() => {
    var items = document.querySelectorAll("[adder-group-tooltip]");
    for (var i = 0; i < items.length; i++) {
      var item = items.item(i);
      var code = (item as HTMLElement).getAttribute("adder-group-tooltip");

      if (item.querySelectorAll(".tooltipContent").length > 0 || code !== "EC") return;
      item.appendChild(makeDiv());

      item.addEventListener("mouseover", (e) => {
        var target = e.target as HTMLElement;
        if (target.getAttribute("adder-group-tooltip") === null) {
          var el = target.closest("[adder-group-tooltip]") as HTMLElement;
          (el.querySelector(".tooltipContent") as HTMLElement).style.visibility = "visible";
        } else {
          ((target as HTMLElement).querySelector(".tooltipContent") as HTMLElement).style.visibility = "visible";
        }
      });

      item.addEventListener("mouseout", (e) => {
        var target = e.target as HTMLElement;
        if (target.getAttribute("adder-group-tooltip") === null) {
          var el = target.closest("[adder-group-tooltip]") as HTMLElement;
          (el.querySelector(".tooltipContent") as HTMLElement).style.visibility = "hidden";
        } else {
          ((target as HTMLElement).querySelector(".tooltipContent") as HTMLElement).style.visibility = "hidden";
        }
      });
    }
  }, 1000);
};

// Adds new state option 'redirectTo' to force redirection to another state
app.run([
  "$rootScope",
  "$state",
  ($rootScope: any, $state: any) => {
    $rootScope.$on("$stateChangeStart", (evt: any, to: any, params: any) => {
      if (to.name === "main.usermanagement.search.users") {
        evt.preventDefault();
        window.location.href = getReactUrl() + "/v2/manage-users";
        return;
      }
      if (params.isReact) {
        evt.preventDefault();
        if (to.url.indexOf(":") > -1) {
          to.url = to.url.replace(":igsCustomerNumber", params.igsCustomerNumber);
          to.url = to.url.replace(":abpAccountNumber", params.abpAccountNumber);
          to.url = to.url.replace(":identifier", params.identifier);
          to.url = to.url.replace(":shouldReturnToOpportunity", params.shouldReturnToOpportunity);
          to.url = to.url.replace(":isPtoLetterOnly", params.isPtoLetterOnly);
          to.url = to.url.replace(":partnerSystemNumber", params.partnerSystemNumber);
          to.url = to.url.replace(":systemKey", params.systemKey);
        }

        var url = getReactUrl() + to.url;
        window.open(url, "_self");
      }
      if (to.redirectTo) {
        evt.preventDefault();
        $state.go(to.redirectTo, params, { location: "replace" });
      }
    });

    $rootScope.$on("igs-wait-mask-hide", (evt: any, to: any, params: any) => {
      handleAdderGroupTooltip();
    });
  },
]);
